import styled, { css } from 'styled-components';
import { StyledWarehouseProductCardListProps } from './types';

export const StyledWarehouseProductCardList = styled.ul<StyledWarehouseProductCardListProps>`
  ${({ isHorizontal }) =>
    isHorizontal
      ? css`
          width: 100%;
        `
      : css`
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
          gap: var(--s-4);
        `};
`;

export const StyledWarehouseProductCardListItem = styled.li<StyledWarehouseProductCardListProps>`
  ${({ isHorizontal }) =>
    isHorizontal &&
    css`
      &:not(:last-child) {
        margin-bottom: var(--s-2);
      }
    `}
`;

export const ProductsPlaceholderWrapper = styled.div`
  > div {
    margin: 0;

    h3 {
      text-align: start;
    }
  }
`;

export const StyledListSentinel = styled.div`
  width: 100%;
  height: 1px;
`;

export const StyledListFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--s-2);
  padding: var(--s-4) 0 var(--s-2);
`;

export const StyledListProgress = styled.span`
  font-size: var(--t-sm);
  color: var(--muted);
  font-variant-numeric: tabular-nums;
`;
